module.exports = __webpack_public_path__ + "87487447185088ae4aea428e0b9ff1f2.pdf";